import { render } from "./vip-modify.vue?vue&type=template&id=9fc7d482&scoped=true&ts=true"
import script from "./vip-modify.vue?vue&type=script&lang=ts"
export * from "./vip-modify.vue?vue&type=script&lang=ts"

import "./vip-modify.vue?vue&type=style&index=0&id=9fc7d482&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fc7d482"]])

export default __exports__